const BLOCKED_CARD_FUNDING_TYPES = ["debit", "prepaid", "unknown"];
const CARD_EXPIRY_THRESHOLD_MONTHS = 2;

export function validateCard(card) {
  if (!card) {
    return "Only credit cards are accepted for this workspace.";
  }

  if (BLOCKED_CARD_FUNDING_TYPES.includes(card.funding)) {
    return "Only credit cards are accepted. Debit and prepaid cards are not supported.";
  }

  const now = new Date();
  const expiryDate = new Date(card.exp_year, card.exp_month, 0);
  const thresholdDate = new Date(
    now.getFullYear(),
    now.getMonth() + CARD_EXPIRY_THRESHOLD_MONTHS,
    now.getDate()
  );
  if (expiryDate <= thresholdDate) {
    return "This card expires too soon. Please use a card valid for at least the next 2 months.";
  }

  return null;
}
